export default "__VITE_ASSET__e0287639__"